var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
var ExportJobsPagination = /** @class */ (function (_super) {
    __extends(ExportJobsPagination, _super);
    function ExportJobsPagination() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pageSize = _this.initialPageSize;
        _this.nextCursor = null;
        _this.cursorStack = [];
        return _this;
    }
    Object.defineProperty(ExportJobsPagination.prototype, "initialPageSize", {
        get: function () {
            return 25;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExportJobsPagination.prototype, "currentPage", {
        get: function () {
            return this.cursorStack.length + 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExportJobsPagination.prototype, "canGoBack", {
        get: function () {
            return this.cursorStack.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExportJobsPagination.prototype, "canGoNext", {
        get: function () {
            return this.nextCursor !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExportJobsPagination.prototype, "hasMultiplePages", {
        get: function () {
            return this.cursorStack.length > 0 || this.nextCursor !== null;
        },
        enumerable: false,
        configurable: true
    });
    ExportJobsPagination.prototype.reset = function () {
        this.pageSize = this.initialPageSize;
        this.nextCursor = null;
        this.cursorStack = [];
    };
    return ExportJobsPagination;
}(Entity));
export { ExportJobsPagination };
